import React from "react";

const LazyVideo = React.forwardRef(
  ({ autoPlay, muted, loop, controls, preload, deviceVideoSrc }, ref) => (
    <video
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      ref={ref}
      controls={controls}
      preload={preload}
    >
      <source src={deviceVideoSrc} type="video/mp4" />
    </video>
  )
);

export default LazyVideo;
